import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45set_45token_45global from "/app/middleware/00.setToken.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _00_45set_45token_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  authentication: () => import("/app/middleware/authentication.ts"),
  auth: () => import("/app/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.mjs")
}